import { render, staticRenderFns } from "./TutorEditTraffic.vue?vue&type=template&id=8f18e6f0"
import script from "./TutorEditTraffic.vue?vue&type=script&lang=js"
export * from "./TutorEditTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports